import { PaymentCycle } from '../consts';

export enum CheckoutErrorType {
  SUBMIT_VALIDATION_ERROR = 'SUBMIT_VALIDATION_ERROR',
  SUBMIT_BUSINESS_ERROR = 'SUBMIT_BUSINESS_ERROR',
  SUBMIT_FATAL_ERROR = 'SUBMIT_FATAL_ERROR',
}

export enum BiEventIDs {
  ORDER_PAGE_VALIDATION_ERROR = 105,
  ORDER_PAGE_FATAL_ERROR = 177,
  ORDER_PAGE_SUBMIT_PRESSED = 178,
  ORDER_PAGE_BUSINESS_ERROR = 176,
  CHECKOUT_PAGE_VIEW_TOOLTIP = 3916,
  PACKAGE_PICKER_LOADED = 940,
  A_PLAN_SELECTED = 3905,
  A_CYCLE_SELECTED = 3906,
  A_PAYMENT_PAGE_READY = 942,
  HOVER_ON_FEATURES = 3910,
  CHANGE_PP_TYPE = 3912,
  TABS_TOOLTIP_CLOSED = 3913,
  PREVIOUS_STEP_SELECT = 3907,
  R_PREMIUM_ORDER_PAGE_SUMBIT_SUCCESS = 3103,
  R_PREMIUM_ORDER_PAGE_SUBMIT_PENDING = 3104,
  R_PREMIUM_ORDER_PAGE_SUBMIT_PENDING_BOLETO = 3202,
  A_VIEW_DOUBLE_PURCHASE_POPUP = 1220,
  A_DOUBLE_PURCHASE_POPUP_VIEW_BUTTON_CLICKED = 1221,
  REQUEST_CALL_POPUP_LOAD = 3914,
  REQUEST_CALL_POPUP_CTA = 3915,
  VIEW_PRODUCT_FEATURE_TOOLTIP = 3910,
  CHANGE_PLAN_POPUP_OPENED = 7900,
  CHANGE_PLAN_POPUP_CLICK_CHANGE = 7901,
  CHANGE_PLAN_POPUP_CLOSED = 7902,
  VIEW_CURRENT_PLAN_MODAL_OPENED = 7503,
  VIEW_CYCLE_DISCOUNT_TOOLTIP = 3916,
  CLICK_ON_FAQ_ITEM = 3917,
  CLICK_ON_SHOW_FEATURES = 3918,
  CLICK_ON_SHOW_ALL_FEATURES = 3919,
  STICKY_HEADER_MOBILE_GRID = 3903,
  SELECT_PLAN_RADIO_BUTTONS_MOBILE_GRID = 3904,
}

export enum DayfulBiEventIds {
  PACKAGE_PICKER_LOADED = 840,
  VIEW_CYCLES = 3805,
}

export const PaymentCycle_BIMap = {
  [PaymentCycle.MONTHLY]: 3,
  [PaymentCycle.YEARLY]: 6,
  [PaymentCycle.YEAR2]: 7,
  [PaymentCycle.YEAR3]: 8,
  [PaymentCycle.YEAR4]: undefined,
  [PaymentCycle.YEAR5]: undefined,
  [PaymentCycle.QUARTERLY]: 4,
};
